module.exports = __webpack_public_path__ + "static/media/down-arrow.735d1ce4.png";